export default {
    token(state) {
        return state.token;
    }
};